import { render, staticRenderFns } from "./Create1.vue?vue&type=template&id=b00627c2&scoped=true"
import script from "./Create1.vue?vue&type=script&lang=js"
export * from "./Create1.vue?vue&type=script&lang=js"
import style0 from "./Create1.vue?vue&type=style&index=0&id=b00627c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00627c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b00627c2')) {
      api.createRecord('b00627c2', component.options)
    } else {
      api.reload('b00627c2', component.options)
    }
    module.hot.accept("./Create1.vue?vue&type=template&id=b00627c2&scoped=true", function () {
      api.rerender('b00627c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Create1.vue"
export default component.exports